export default function initBackToTop() {
  const toTop = document.getElementById('back-to-top')
  if (!toTop) return

  const toggle = () => {
    toTop.classList.toggle('is-visible', window.scrollY > 500)
  }

  window.addEventListener('scroll', toggle, { passive: true })
  toggle()

  toTop.addEventListener('click', (e) => {
    e.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
}
